import { Card, CardContent } from '@/components/ui/card'
import { RocklakeLineState } from '@/models/insuranceApplication'
import { CoverageType } from '@/models/insuranceCoverage'
import { RocklakeLineRow } from './RocklakeLineRow'

const ROCKLAKE_ICON_URL = 'https://static.cai.insure/carriers/rocklake-icon.png'

/** Staff-only: Rocklake lines that go only when staff send them, until each one is sent. */
export function RocklakeLinesCard({
  lines,
  applicationId,
  orgId,
}: {
  lines: Partial<Record<CoverageType, RocklakeLineState>>
  applicationId: string
  orgId?: string
}) {
  const unsent = (Object.entries(lines) as [CoverageType, RocklakeLineState][]).filter(
    ([, state]) => state !== RocklakeLineState.SENT
  )
  if (!unsent.length) return null

  return (
    <Card>
      <CardContent className="text-muted-foreground font-semibold">
        <div className="grid grid-cols-[48px_1fr] gap-6">
          <img src={ROCKLAKE_ICON_URL} alt="Rocklake" className="h-12 w-12 object-contain" />
          <div className="flex min-w-0 flex-col gap-4">
            <div className="text-general-foreground space-y-1">
              <div className="text-md font-semibold">Rocklake</div>
              <div className="text-muted-foreground text-sm font-normal">
                These lines go to Rocklake only when you send them.
              </div>
            </div>
            {unsent.map(([coverage, state]) => (
              <RocklakeLineRow
                key={coverage}
                coverage={coverage}
                state={state}
                applicationId={applicationId}
                orgId={orgId}
              />
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
